import React, { useEffect, useState } from 'react';
import { FormBuilder, Formio } from '@formio/react';
import ar from './i18n/ar.json';
import en from './i18n/en.json';
import { useCookieContext } from "../../contexts";

interface FormBuilderComponentProps {
    formSchema: any;
    setFormSchema: (schema: any) => void;
}

const FormBuilderComponent: React.FC<FormBuilderComponentProps> = ({ formSchema, setFormSchema }) => {
    const { isAr } = useCookieContext();
    const [key, setKey] = useState(0); // Used to force re-render

    useEffect(() => {
        setKey(prevKey => prevKey + 1); // Change key to force re-render
    }, [isAr]); // Re-run when language changes

    const onChange = (schema: any) => {
        setFormSchema(schema);
    };

    return (
        <div>
            <FormBuilder
                key={key} // Forces re-render when language changes
                form={formSchema}
                onChange={onChange}
                options={{
                    language: isAr ? 'ar' : 'en',
                    i18n: {
                        ar,
                        en
                    }
                }}
            />
        </div>
    );
};

export default FormBuilderComponent;